import { render } from "./PendingJobs.vue?vue&type=template&id=ef55e740"
import script from "./PendingJobs.vue?vue&type=script&lang=js"
export * from "./PendingJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__